import Vue from 'vue';

import gygIntegration from '@/components/otas/getYourGuide/integration/otaIntegration.vue'
import gygHowToConnect from '@/components/otas/getYourGuide/howToConnect/howToConnect.vue'

const state = {
    presentOTAs: [
        {
            id: 1,
            channelType: 202,
            name: "GetYourGuide",
            website: "https://www.getyourguide.com/",
            logo: require('@/assets/images/otas/getYourGuideLogo.svg'),
            description: 'Manage all bookings from your GetYourGuide account. Make sure your account with GetYourGuide is active and connect with Pluralo.',
            howToConnect: gygHowToConnect,
            integration: {
                otaLink: 'https://supplier-support.getyourguide.com/',
                textSmall: 'Log into your <a href="https://supplier-support.getyourguide.com/" target="_blank" class="color-1 bold">Supply Portal</a> and using the table bellow connect Pluralo’s Products ID.<br><b>Follow the GYG instructions guide to finish the connection on their site.</b>',
                helpLink: 'https://help.pluralo.com/ota/gyg/Config.pdf',
                integrationComponent: gygIntegration,
            }
        }
    ]

};

const getters = {
    getOTAs: (state) => state.presentOTAs,

};

const actions = {
    // Possible deprecation
    getOtaAgentInfo: function ({state, rootState}, channelId) {
        return Vue.axios.get('/api/supplier/GetChannel', {
            params: {
                supplierId: rootState.user.account.supplierId,
                channelId: channelId
            }
        }).then(response => {
            return response
        }).catch(err => {
            return err
        })
    },

    // Possible deprecation
    updateOtaAgentInfo: function ({state, rootState, dispatch}, channel) {
        return Vue.axios.post('/api/supplier/editChannel', {
            supplierId: rootState.user.account.supplierId,
            channel: channel
        }).then(response => {
            dispatch('initAgents'); //reloads agent list
            return response
        }).catch(error => {
            return error
        })
    },

    getOTAByChannelType: function ({state}, channelType) {
        return state.presentOTAs.find(ota => {return ota.channelType == channelType})
    },

    // GYG
    connectToGetYourGuide: function ({state, commit, rootState}) {
        return Vue.axios.get('/api/supplier/ActivateGYGChannel', {
            params: {
                supplierId: rootState.user.account.supplierId,
            }
        }).then(response => {
            if(response.status == 200){
                //add GYG agent (that is really a OTA) to agent list
                commit('PUSH_AGENT_TO_AGENTS', response.data)
                return response
            } else {
                return false
            }
        }).catch(error => {
            return false
        })
    }
};

const mutations = {

};

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/ota.js